import { render, staticRenderFns } from "./Shareholders.handler.vue?vue&type=template&id=5f328220&"
import script from "./Shareholders.handler.vue?vue&type=script&lang=ts&"
export * from "./Shareholders.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports